import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { API } from "@/lib/api";
import { PageHeader, Card, Button, Field, Select } from "@/components/UI";
import {
  CloudArrowDown, FileXls, Database, ShieldCheck, ArrowsClockwise,
  FilePdf, UploadSimple, CheckCircle, XCircle, ArrowRight,
  ArrowCounterClockwise, PaperPlaneTilt, Warning,
} from "@phosphor-icons/react";
import { IMPORT_TYPES } from "./constants";

export function MonthlyReportSection() {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [busy, setBusy] = useState(false);

  const MONTHS = ["", "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
                  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

  const download = async () => {
    setBusy(true);
    try {
      const mStr = String(month).padStart(2, "0");
      const res = await fetch(`${API}/reports/monthly-pdf?month=${year}-${mStr}`, {
        credentials: "include",
      });
      if (!res.ok) {
        let msg = "PDF indirilemedi";
        try { const j = await res.json(); msg = j.detail || msg; } catch { /* JSON değilse default */ }
        throw new Error(msg);
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `sutciftlik-yonetim-raporu-${year}-${mStr}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`${MONTHS[month]} ${year} raporu indirildi`);
    } catch (e) {
      toast.error(e.message || "Hata");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="mb-6 p-4 rounded-md border-2 border-[#417251] bg-[#E4EEE6]" data-testid="report-info">
        <div className="flex items-start gap-3">
          <FilePdf size={22} weight="duotone" className="text-[#2D4A36] shrink-0 mt-0.5" />
          <div className="flex-1">
            <div className="font-semibold text-[#1F3B26] mb-1">📄 Muhasebeci & İş Ortağı Sunumu</div>
            <div className="text-sm text-[#2D4A36] leading-relaxed">
              Ay seçin, tek tıkla profesyonel PDF üretilsin. Yönetici özeti, gelir/gider kırılımı, personel bordrosu, veteriner aktivitesi, sürü durumu ve stok tüketimi otomatik gelir. Türkçe.
            </div>
          </div>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Card testId="report-picker-card">
          <h3 className="heading text-xl mb-4">Ay Seç</h3>
          <div className="grid grid-cols-2 gap-3 mb-4">
            <Field label="Yıl *">
              <Select data-testid="report-year" value={year} onChange={e => setYear(Number(e.target.value))}>
                {Array.from({ length: 6 }, (_, i) => now.getFullYear() - i).map(y => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </Select>
            </Field>
            <Field label="Ay *">
              <Select data-testid="report-month" value={month} onChange={e => setMonth(Number(e.target.value))}>
                {MONTHS.slice(1).map((m, i) => (
                  <option key={m} value={i + 1}>{m}</option>
                ))}
              </Select>
            </Field>
          </div>
          <div className="text-sm text-[#5e675e] mb-4 bg-[#F7F6F3] border border-[#EEECE5] rounded p-3">
            <b>Seçilen dönem:</b> {MONTHS[month]} {year}
          </div>
          <Button onClick={download} disabled={busy} data-testid="report-download-btn" className="w-full">
            <FilePdf size={18} weight="bold" className="inline mr-2" />
            {busy ? "PDF hazırlanıyor..." : "Aylık Yönetim Raporu (PDF) İndir"}
          </Button>
        </Card>

        <Card testId="report-content-card">
          <h3 className="heading text-xl mb-4">Rapor İçeriği</h3>
          <ul className="text-sm text-[#5e675e] space-y-2">
            {[
              "Yönetici Özeti — 8 KPI (gelir, gider, kâr, süt, hayvan, personel...)",
              "Süt Üretimi — Normal + Antibiyotikli miktar & gelir",
              "Finansal Kırılım — Gelir/gider kategorileri, yüzdeler",
              "Personel & Bordro — Aktif personel, ödeme türleri",
              "Veteriner Aktivitesi — Tohumlama, gebelik, doğum, tedavi",
              "Sürü Durumu — Cinsiyet dağılımı, aktif sayı",
              "Stok Tüketim Özeti — Kalem bazında maliyet",
            ].map((it, i) => (
              <li key={it} className="flex items-start gap-2">
                <CheckCircle size={14} weight="fill" className="text-[#417251] mt-0.5 shrink-0" />
                <span>{it}</span>
              </li>
            ))}
          </ul>
          <div className="mt-4 text-xs text-[#8a938c] italic">
            Not: Rapor <b>sadece Admin (İşletme Sahibi)</b> tarafından indirilebilir. Müdür, veteriner ve personel bu rapora erişemez.
          </div>
        </Card>
      </div>
    </div>
  );
}

/* ---------------------------- EXCEL İÇE AKTARIM ---------------------------- */
